/**
 * Utility function to dynamically set the document title based on the current URL
 * Extracts the subdomain from URLs like "apix-test.apix.co" and formats it as "Apix-Test2 - Apix"
 */
export const setDynamicTitle = () => {
  try {
    const hostname = window.location.hostname;
    
    // Check if the hostname contains 'apix.co'
    if (hostname.includes('apix.co')) {
      // Extract everything before 'apix.co'
      const parts = hostname.split('.apix.co')[0];
      
      if (parts && parts !== 'apix.co') {
        // Split by hyphens and capitalize each part
        const titleParts = parts.split('-').map(part => 
          part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
        );
        
        // Join with hyphens and add " - Apix" suffix
        const dynamicTitle = `${titleParts.join('-')} - Apix`;
        document.title = dynamicTitle;
      } else {
        // If it's just apix.co, set a default title
        document.title = 'Apix';
      }
    } else {
      // For localhost or other domains, keep the original title or set a default
      if (hostname === 'localhost' || hostname.startsWith('127.0.0.1')) {
        document.title = 'Local - APIX';
      } else {
        // For any other domain, try to extract a meaningful title
        const parts = hostname.split('.');
        if (parts.length > 1) {
          const subdomain = parts[0];
          const titleParts = subdomain.split('-').map(part => 
            part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
          );
          document.title = `${titleParts.join('-')} - Apix`;
        } else {
          document.title = 'APIX';
        }
      }
    }
  } catch (error) {
    console.warn('Error setting dynamic title:', error);
    // Fallback to original title
    document.title = 'Archive-APIX';
  }
};

export default setDynamicTitle;

